import TextareaAutosize from 'react-textarea-autosize';
import styled from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

import { ComponentProps } from './interfaces';

type Props = ComponentProps & {
  error: string;
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: stretch;
  width: 100%;

  @media ${device.isDesktop}, ${device.isTablet} {
    max-width: 350px;
  }
`;

export const Label = styled.label`
  align-self: stretch;
  font-family: VIC;
  font-weight: 600;
  overflow-wrap: break-word;
  margin-bottom: 8px;
  color: ${colors.blueGrey};
`;

export const HintLabel = styled(Label)`
  font-weight: 400;
  margin-top: 8px;
  color: ${colors.blueGrey75};
`;

export const ErrorLabel = styled(Label)`
  color: ${colors.red};
  margin-top: 8px;
  font-weight: 400;
`;

// export const TextArea = styled.textarea<Props>`
export const TextArea = styled(TextareaAutosize)<Props>`
  padding: 11.5px 16px !important;
  ${props =>
    props.mode === 'Input' &&
    `overflow: hidden !important;
  `};
  align-self: stretch;
  height: 152px;
  border-radius: 2px;
  font-size: 1rem;
  font-family: VIC;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  outline: 0px !important;
  color: ${colors.blueGrey};
  resize: ${props => (props.mode !== 'Input' ? 'auto' : 'none')};
  border: solid 1px
    ${props =>
      props.error == 'true' ? colors.red : props.disabled ? colors.darkGrey75 : colors.blueGrey};
  background-color: ${props => (props.disabled ? colors.darkGrey10 : colors.white)};
  padding: 0 16px;

  ${props =>
    props.disabled
      ? ' cursor: not-allowed;'
      : `:active,
:focus {
  border: solid 1px ${colors.orange};
}`};
`;
